import { useIntl } from '@/intl'
import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    day: (dayNumber: uui.domain.client.rm.WeekDay) =>
      translate({ id: `recurrence.weekDay.${dayNumber}` }),
    cardinal: (cardinalNumber: uui.domain.client.rm.WeekOfMonth) =>
      translate({ id: `recurrence.cardinal.${cardinalNumber}` }),
    month: (monthNumber: uui.domain.client.rm.MonthNumber) =>
      translate({ id: `recurrence.month.${monthNumber}` }),
    description: {
      daily: translate({ id: 'recurrence.description.daily' }),

      weekly: (period: number, weekday: uui.domain.client.rm.WeekDay) =>
        translate({
          id: `recurrence.description.weekly`,
          values: { period, weekday: api.day(weekday) },
        }),

      monthlyOnDate: (period: number, date: string) =>
        translate({ id: `recurrence.description.monthlyOnDate`, values: { period, date } }),

      monthlyOnCardinal: (
        period: number,
        cardinal: uui.domain.client.rm.WeekOfMonth,
        weekday: uui.domain.client.rm.WeekDay,
      ) =>
        translate({
          id: `recurrence.description.monthlyOnCardinal`,
          values: { period, cardinal: api.cardinal(cardinal), weekday: api.day(weekday) },
        }),

      annuallyOnDate: (period: number, date: string) =>
        translate({ id: `recurrence.description.annuallyOnDate`, values: { period, date } }),

      annuallyOnCardinal: (
        period: number,
        cardinal: uui.domain.client.rm.WeekOfMonth,
        weekday: uui.domain.client.rm.WeekDay,
        month: uui.domain.client.rm.MonthNumber,
      ) =>
        translate({
          id: `recurrence.description.annuallyOnCardinal`,
          values: {
            period,
            cardinal: api.cardinal(cardinal),
            weekday: api.day(weekday),
            month: api.month(month),
          },
        }),

      endsOnDate: (date: string) =>
        translate({ id: `recurrence.description.endsOnDate`, values: { date } }),

      endsAfterNumber: (occurrences: number) =>
        translate({ id: `recurrence.description.endsAfterOccurrences`, values: { occurrences } }),
    },
  }))

  return api
}
